import * as React from "react"
import { X, CheckCircle, AlertCircle, Info } from "lucide-react"
import { useToast, type ToastVariant } from "./use-toast";
import { cn } from "@/lib/utils"

const variantStyles: Record<ToastVariant, string> = {
  default: "bg-background border",
  destructive: "bg-destructive text-destructive-foreground border-destructive",
  success: "bg-success-100 text-success-700 border-success-200",
}

const variantIcons: Record<ToastVariant, React.ReactNode> = {
  default: <Info className="h-4 w-4 text-info" />,
  destructive: <AlertCircle className="h-4 w-4" />,
  success: <CheckCircle className="h-4 w-4 text-success-700" />,
}

function Toaster() {
  const { toasts, dismiss } = useToast()

  return (
    <div className="fixed bottom-0 right-0 z-[100] flex max-h-screen w-full flex-col-reverse gap-2 p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col-reverse md:max-w-[420px]">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={cn(
            "pointer-events-auto relative flex w-full items-start gap-3 overflow-hidden rounded-lg p-4 shadow-lg transition-all animate-in slide-in-from-bottom-5",
            variantStyles[t.variant || "default"]
          )}
        >
          <div className="mt-0.5">{variantIcons[t.variant || "default"]}</div>
          <div className="flex-1 space-y-1">
            {t.title && <p className="text-sm font-semibold leading-none">{t.title}</p>}
            {t.description && <p className="text-sm opacity-90">{t.description}</p>}
          </div>
          <button
            onClick={() => dismiss(t.id)}
            className="rounded-md p-1 opacity-70 transition-opacity hover:opacity-100"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      ))}
    </div>
  )
}

export { Toaster }
